export default __webpack_public_path__ + "static/media/144.17eb568b.jpg";